import { makeStyles } from 'tss-react/mui';
import { listItemStyles, menuListStyles, menuPaperStyles } from '../../../themes/v2/theme.base';

export const usePhoneFieldStyles = makeStyles()((theme) => ({
  container: {
    position: 'relative',
    width: '100% !important',
    paddingRight: '8px !important',
    '& input:focus': {
      boxShadow: `none !important`,
    },
    '&.react-tel-input .country-list': {
      ...menuPaperStyles(theme),
      ...menuListStyles(theme),
      position: 'fixed',
      right: 'auto',
      bottom: 'auto',
      margin: 0,
      padding: theme.spacing(0.75),
      overflowY: 'auto',
      overscrollBehavior: 'contain',
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[8],
    },
    '&.react-tel-input .country-list .country': {
      ...listItemStyles(theme),
      fontSize: theme.typography.body2.fontSize,
      lineHeight: theme.typography.body2.lineHeight,
      padding: theme.spacing(0.75, 0.75, 0.75, 4.75),
      color: theme.palette.text.primary,
      cursor: 'pointer',
      '&.highlight': {
        backgroundColor: theme.palette.action.selected,
      },
    },
    '&.react-tel-input .country-list .flag': {
      top: '50%',
      left: theme.spacing(0.75),
      margin: '-12px 0 0',
    },
    '&.react-tel-input .country-list .dial-code': {
      color: theme.palette.text.secondary,
    },
  },
  input: {
    border: 'inherit !important',
    paddingTop: '0px !important',
    paddingBottom: '0px !important',
    paddingRight: '0px !important',
    paddingLeft: '40px !important',
    width: 'inherit !important',
    fontSize: '14px !important',
  },
  button: {
    position: 'absolute',
    borderTop: 'none !important',
    top: 0,
    bottom: 0,
    '& > .selected-flag': {
      padding: '0px !important',
      maxWidth: '41px',
    },
  },
}));
